// theme.js – übernimmt das Design (hell / dunkel / Kontrast) von Microsoft Teams. Teil der App-Baseline (design/).
// Setzt data-theme am <html>-Element; alle Farben stehen als CSS-Variablen in design.css.
// Bis Teams antwortet, gilt die Systemeinstellung als Vorabwert. Die App ruft
// WbTheme.verbinde() auf, sobald die Teams-SDK initialisiert ist (kein doppeltes initialize()).
(function () {
  "use strict";
  var root = document.documentElement;
  var parameter = null;
  try { parameter = new URLSearchParams(window.location.search).get("theme"); } catch (e) { /* ignorieren */ }

  function wende(theme) {
    if (parameter) return; // ?theme=dark|default|contrast dient dem Testen und hat Vorrang
    root.setAttribute("data-theme", (theme === "dark" || theme === "contrast") ? theme : "default");
  }

  var systemDunkel = !!(window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches);
  root.setAttribute("data-theme", parameter || (systemDunkel ? "dark" : "default"));

  window.WbTheme = {
    verbinde: function () {
      try {
        microsoftTeams.app.getContext().then(function (ctx) {
          if (ctx && ctx.app && ctx.app.theme) wende(ctx.app.theme);
        });
        microsoftTeams.app.registerOnThemeChangeHandler(wende);
      } catch (e) { /* außerhalb von Teams: Vorabwert bleibt */ }
    }
  };
})();
